import React from 'react';
export function DifferentiationSection() {
  return <section className="py-24 bg-white" data-id="element-57" data-mp="15xat1mpe4sg0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58" data-mp="byiq7dulrt8f">
        <div className="bg-slate-50 rounded-3xl p-8 md:p-16 border border-slate-100" data-id="element-59" data-mp="bwz8rjx7nc52">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-60" data-mp="gqk9hjq6uk7y">
            <div data-id="element-61" data-mp="lnty4x5r6ruq">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-62" data-mp="loc3cjae8ges">
                Why I'm Not Your Average <br data-id="element-63" data-mp="3k8bw0ilk2byr" />
                "Passionate Copywriter"
              </h2>
              <p className="text-lg text-slate-600 mb-8" data-id="element-64" data-mp="3p6dhtbad8pdx">
                Most copywriters focus on word count and "sounding nice." I
                focus on one metric:{' '}
                <span className="font-bold text-slate-900" data-id="element-65" data-mp="214mmets2yxj">
                  Revenue per visitor.
                </span>
              </p>
              <p className="text-lg text-slate-600 mb-8" data-id="element-66" data-mp="19e6e8vb5juwe">
                I work with fewer clients intentionally so I can dive deep into
                your business model. I don't just hand over a Google Doc and
                disappear; I strategize with you on how to deploy the copy for
                maximum impact.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-67" data-mp="t1qze8119rwu">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-68" data-mp="p0xbhenlcd3y">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-69" data-mp="p39ulv534til">
                  ROI
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-70" data-mp="fbdpi04l034v">Focused</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-71" data-mp="f9aqwrpd51oj">
                  I track conversions, not just clicks.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-72" data-mp="5e93q1ene9ol">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-73" data-mp="1ab31m9ocqtf">
                  Psych
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-74" data-mp="3si5q7pn0uwug">Driven</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-75" data-mp="3its0jyj2eu6a">
                  Based on behavioral psychology.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-76" data-mp="3mtisi5kbvgce">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-77" data-mp="38xyiy0qhoahn">
                  Deep
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-78" data-mp="5f57bth9tvq4">Research</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-79" data-mp="5fx1czv7zlea">
                  I know your customer better than they do.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-80" data-mp="3rvhr7254hp30">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-81" data-mp="nn757n2nz67">
                  Zero
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-82" data-mp="od7rnuyvj4hl">Fluff</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-83" data-mp="t57zsap3l3p9">
                  Every word earns its place on the page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}